export default {
  clearFormationState: ({ commit }) => commit("CLEAR_FORMATION_STATE"),

  index: ({ commit }, payload) => commit("index", payload),

  store: ({ commit }, payload) => commit("store", payload),

  update: ({ commit }, payload) => commit("update", payload),

  delete: ({ commit }, payload) => commit("delete", payload)
};
